<div class="mt-10 w-full px-4 py-4 sm:mt-20 sm:px-8">
  <dhp-breadcrumbs [crumbs]="breadcrumbs"></dhp-breadcrumbs>
</div>

<div class="mt-6 w-full px-4 md:px-8 lg:px-16">
  <h1
    class="mt-20 mb-2 bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
    style="
      background: linear-gradient(
        to right,
        #008b79 0%,
        #008c6c 27%,
        #169999 60%,
        #004365 100%
      );
      background-clip: text;
    "
  >
    {{ 'pages.advertisementPage.title' | translate }}
  </h1>
</div>

<hr class="mb-6 border-neutral-300 sm:mb-10" />

<div class="mt-10 w-full px-4 py-4 sm:mt-20 sm:px-8">
  <div class="flex flex-col lg:flex-row">
    <div class="mb-6 w-full lg:mb-0 lg:w-1/2">
      <div class="text-lg leading-normal font-medium text-orange-500">
        {{ 'pages.advertisementPage.adAndBannerPlacements' | translate }}
      </div>
    </div>
    <div class="w-full lg:w-1/2">
      <div class="flex flex-col gap-6 sm:gap-10">
        <div>
          <h2
            class="mb-4 text-2xl leading-tight font-medium text-neutral-800 sm:text-3xl md:text-4xl"
          >
            {{ 'pages.advertisementPage.websiteBanner' | translate }}
          </h2>
        </div>
        <div class="border-t border-b border-neutral-300">
          <div
            class="flex flex-col items-start justify-between py-4 sm:flex-row sm:items-center sm:py-5"
          >
            <div
              class="mb-2 text-base leading-normal font-medium text-neutral-800 sm:mb-0 sm:text-lg"
            >
              {{ 'pages.advertisementPage.oneMonthPlacement' | translate }}
            </div>
            <div
              class="text-left text-base leading-normal font-normal text-neutral-600 sm:text-right sm:text-lg"
            >
              {{
                'pages.advertisementPage.oneMonthPrice'
                  | translate: { price: 2100, extraMonthPrice: 900 }
              }}
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4 sm:gap-5">
          <div class="text-sm leading-relaxed font-normal text-neutral-500">
            {{ 'pages.advertisementPage.freeAdInfo' | translate }}
          </div>
          <div class="text-sm leading-relaxed font-normal text-neutral-500">
            {{ 'pages.advertisementPage.discountInfo' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mt-10 mb-5 w-full px-4 py-4 sm:mt-20 sm:px-8">
  <div class="flex flex-col lg:flex-row">
    <div class="mb-6 w-full lg:mb-0 lg:w-1/2">
      <div class="text-lg leading-normal font-medium text-orange-500">
        {{ 'pages.advertisementPage.materialsAndFormats' | translate }}
      </div>
    </div>
    <div class="w-full lg:w-1/2">
      <div class="flex flex-col gap-10">
        <div>
          <h2
            class="mb-4 text-2xl leading-tight font-medium text-neutral-800 sm:text-3xl md:text-4xl"
          >
            {{ 'pages.advertisementPage.formatsAndMaterials' | translate }}
          </h2>
        </div>

        <div class="border-t border-b border-neutral-300">
          <!-- First item -->
          <div
            class="flex flex-col items-start justify-between py-4 sm:flex-row sm:items-center sm:py-5"
          >
            <div
              class="mb-2 text-lg leading-normal font-medium text-neutral-800 sm:mb-0"
            >
              {{ 'pages.advertisementPage.websiteBannerFormat' | translate }}
            </div>
            <div
              class="text-right text-lg leading-normal font-normal text-neutral-600"
            >
              {{ 'pages.advertisementPage.websiteBannerSize' | translate }}
            </div>
          </div>
          <!-- Second item -->
          <div
            class="flex flex-col items-start justify-between border-t border-neutral-300 py-4 sm:flex-row sm:py-5"
          >
            <div
              class="mb-2 text-lg leading-normal font-medium text-neutral-800 sm:mb-0"
            >
              {{ 'pages.advertisementPage.printAdMaterial' | translate }}
            </div>
            <div class="flex flex-col items-end">
              <div
                class="text-right text-lg leading-normal font-normal text-neutral-600"
              >
                {{ 'pages.advertisementPage.pageSize' | translate }}
              </div>
              <div
                class="text-right text-lg leading-normal font-normal text-neutral-600"
              >
                {{ 'pages.advertisementPage.printArea' | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- Additional info -->
        <div class="flex flex-col gap-5">
          <div class="text-sm leading-relaxed font-normal">
            <span class="font-bold text-neutral-800">{{
              'pages.advertisementPage.warning' | translate
            }}</span>
            <span class="text-neutral-500">
              {{ 'pages.advertisementPage.warningText' | translate }}
            </span>
          </div>
          <div class="text-sm leading-relaxed font-normal text-neutral-500">
            {{ 'pages.advertisementPage.paymentTerms' | translate }}
          </div>
          <div class="text-sm leading-relaxed font-normal text-neutral-500">
            {{ 'pages.advertisementPage.termsAndConditions' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<dhp-our-subscriptions></dhp-our-subscriptions>
